define('../src/sublayouts/m16-graph/m16-graph',['jquery', 'tooltipster'], function($, tooltipster) {

    'use strict';

    var M16_GRAPH = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M16_GRAPH.prototype.init = function() {
        var _this = this;

        _this.start();
        this.$component.off('reinit').on('reinit', function () {
            _this.start();
        });
    };

    M16_GRAPH.prototype.start = function() {
        var _this = this,
            data = JSON.parse(this.$component.attr('data-graph-series')),
            max = Math.max.apply(Math, data.map(function(o) {
                return o.y;
            })) * 1.1;

        _this.$component.html('');

        function numberWithCommas(number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }

        $(data).each(function() {
            var thisVal = numberWithCommas(this.y);
            _this.$component.append('<div class="m16-graph--item" m16-graph--item=' + this.y + ' style="background-color:' + this.color + '"><div class="m16-graph--label">' + this.name + '</div><div class="m16-graph--value">' + thisVal + '</div></div>')
        });

        this.$component.find('.m16-graph--item').each(function() {
            var barWidth = (parseFloat($(this).attr('m16-graph--item')) / max) * 100,
                name = $(this).find('.m16-graph--label').text(),
                $bar = $(this);

            setTimeout(function () {
                $bar.css('width', barWidth.toString() + '%');
            },25)

            $(this).tooltipster({
                content: name+': '+$(this).attr('m16-graph--item'),
                maxWidth: 250,
                arrow: false
            });

            setTimeout(function() {
                if ($bar.width() < 75) {
                    $bar.addClass('noicon');
                } else {
                    $bar.removeClass('noicon');
                };
            }, 750);
        });

        $(window).off('resize.m16').on('resize.m16', function() {
            _this.$component.find('.m16-graph--item').each(function() {
                if ($(this).width() < 75) {
                    $(this).addClass('noicon');
                } else {
                    $(this).removeClass('noicon');
                };
            });
        });
    };

    return M16_GRAPH;
});

